import { type ReactNode, createContext, useContext } from "react"
import { FAZ_CRED } from "./fazcred"
import type { Parceiro } from "./tipos"

const ParceiroContext = createContext<Parceiro>(FAZ_CRED)

export const ParceiroProvider = ({
    parceiro,
    children,
}: { parceiro: Parceiro; children: ReactNode }) => (
    <ParceiroContext.Provider value={parceiro}>{children}</ParceiroContext.Provider>
)

export const useParceiro = () => useContext(ParceiroContext)
